import { useSnackbar } from "notistack";
import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Bloco, ISbloco } from "../../types/bloco/Bloco";
import { Panel } from "primereact/panel";
import { BlocoForm } from "./BlocoForm";
import { useCreateBloco1Mutation, useCreateBlocoMutation } from "./blocoApiSlice";
import errorFormat from "../../utils/errorFormat";
import { useNavigate } from "react-router-dom";
import configUrls from "../../config/configUrls";


export const BlocoCreate = () => {

    const [bloco, setBloco] = useState<Bloco>(ISbloco);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createBloco, status] = useCreateBloco1Mutation();
    const navigate = useNavigate();


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setBloco((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        await createBloco(bloco);
    }
//criar o excluir do bloco
    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(configUrls.BLOCO_LIST);
            // setBloco(ISbloco);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Blocos 
                </Typography>



                <BlocoForm
                    data={bloco}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />

            </Paper>










        </>







    );










};

/*
 <BlocoTurmaForm
                    blocoTurma={blocoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/